// extracted by mini-css-extract-plugin
module.exports = {"arrow":"arrow-ncOVP","arrow_prev":"arrow_prev-2pbuy","arrow_next":"arrow_next-2elLu"};